class PostTemplate {
	getElement(post) {
		const div = document.createElement('div');
		div.innerHTML = this.getHtml(post);
		return div.firstElementChild;
	}

	getHtml(post) {
		// console.log(post) // Odkomentuj jeżeli chcesz sprawdzić dostępnę wartości na widoku
		const publicationDate = post.published.split(' ')[0].split('-').reverse().join('.');

		const image = post.imageLink ? /* html */ `
			<picture>
				<img src="${post.imageLink}" alt="${post.title}" title="${post.title}" class="blog-post__img img-responsive">
			</picture>
		` : '';

		return /* html */`
			<a class="blog-post-link" href="${post.link}" title="${post.title}">
				<div class="blog-post">
					<div class="blog-post__img-wrapper">
						${image}
					</div>

					<div class="blog-post__text-wrapper">
						<div class="blog-post__date">
							<span>${publicationDate}</span>
						</div>
						<h4 class="blog-post__title">${post.title}</h4> 
						<div class="blog-post__description"><p>${post.description}</p></div>
					</div>
				</div>
			</a>
		`;
	}
}

const postTemplate = new PostTemplate();
export {
	PostTemplate,
	postTemplate,
};
